import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import './HomeCard.css'
import HomeLearn from '../HomeLearn/HomeLearn'
import { Zoom } from "react-awesome-reveal"

const HOME_CARD_ITEMS = [
  {
    id: 1,
    iconUrl: "https://res.cloudinary.com/dk50cmtps/image/upload/v1777280689/harrier_l4n6cm.png",
    title: 'Drone',
    description: "Learn more about who we are and the road we've traveled before Tarpots.",
    nav: "/drone_course",
    section: 'DroneSection',
  },
  {
    id: 2,
    iconUrl: 'https://png.pngtree.com/png-clipart/20250218/original/pngtree-ai-technology-tape-sticker-no-background-png-image_20456479.png',
    title: 'Artificial intelligence',
    description: "From smart automation to intelligent decision-making.",
    nav: "/ai_course",
    section: 'AiSection',
  },
]

const getLoggedInUser = () => {
  try {
    const raw = localStorage.getItem('user') || sessionStorage.getItem('user')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

const HomeCard = () => {
  const navigate = useNavigate()

  const visibleItems = useMemo(() => {
    const user = getLoggedInUser()
    const accessSection = user?.accessSection // 'DroneSection' | 'AiSection' | 'ALL' | undefined

    if (accessSection === 'DroneSection' || accessSection === 'AiSection') {
      return HOME_CARD_ITEMS.filter((item) => item.section === accessSection)
    }

    // 'ALL', missing field, or not logged in -> show everything.
    return HOME_CARD_ITEMS
  }, [])

  const goToCourse = (path) => {
    navigate(path)
  }

  return (
    <>
      <section className="home_card_pg_wrapper">
        <div className="home_card_pg_bg3d" aria-hidden="true"></div>

        <Zoom>
          <div className="home_card_pg_grid_row">
            <div className="home_card_pg_grid">
              {visibleItems.map((item) => (
                <div className="home_card_pg_card" key={item.id}>
                  <div className="home_card_pg_icon_wrap">
                    <img
                      src={item.iconUrl}
                      alt={item.title}
                      className="home_card_pg_icon"
                    />
                  </div>
                  <h3 className="home_card_pg_card_title">{item.title}</h3>
                  <p className="home_card_pg_card_desc">{item.description}</p>

                  <button
                    type="button"
                    className="home_card_pg_course_btn"
                    onClick={() => goToCourse(item.nav)}
                  >
                    Course
                  </button>
                </div>
              ))}
            </div>
          </div>
        </Zoom>
      </section>

      <HomeLearn />
    </>
  )
}

export default HomeCard